import { css } from "@emotion/css";
import { useMemo } from "react";

import { Avatar } from "./Avatar";
import { TextAvatar } from "./TextAvatar";
import { AvatarGroupProps } from "./types";

export function AvatarGroup(props: AvatarGroupProps) {
  const {
    avatars,
    total,
    count = 4,
    type = "group",
    testID = "avatar-group",
  } = props;

  const hasOverflow = useMemo(() => total > count, [count, total]);

  return (
    <div
      className={styles.base}
      data-compact={type === "compact" ? "compact" : undefined}
      data-testid={`${testID}-container`}
    >
      {hasOverflow && (
        <TextAvatar label={`+${total - count}`} color="neutral" />
      )}
      {avatars.slice(0, count).map((props) => (
        <Avatar {...props} key={props.testID} />
      ))}
    </div>
  );
}

const styles = {
  base: css({
    display: "inline-flex",
    flexDirection: "row-reverse",
    gap: "var(--space-1)",
    "&[data-compact]": {
      "> div": {
        marginRight: "calc(var(--space-3) * -1)",

        "> div": {
          boxSizing: "border-box",
          border: "2px solid var(--surface-base)",
        },
      },
    },
  }),
};
